export const BLOG_WITH_LEAD_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    content: "",
    article_band_background_color: "",
    background_color: "#FFFFFF",
    enable_padding: true,
    enable_lead_form: true,
    status: false,
  },

  BLOG_WITH_LEAD_FIELDS_CONFIG: [
    {
      fieldName: "content",
      label: "Content",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter article content",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "article_band_background_color",
      label: "Blog page — full article band background",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave blank to use “Background color” below",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Background color (fallback)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "enable_padding",
      label: "Enable Padding",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Padding around the section",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_form",
      label: "Show lead form",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Uses university lead form settings (desktop right / mobile CTA)",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [],
};
